import React from "react";
import { useOutletContext } from "react-router-dom";
import About from "./Component/About";
import Resume from "./Component/Resume";
import type { PortfolioSiteData } from "../types/resume";
import Seo from "../components/Seo";

const AboutWrapper = () => {
  const { data } = useOutletContext<{ data: Partial<PortfolioSiteData> }>();
  if (!data.main || !data.resume) return null;

  return (
    <>
      <Seo
        title="About & Resume — Efwan Rizaldi"
        description="About Efwan Rizaldi — Software Engineer with frontend, Web3 & finance background. View skills, experience and certifications."
        path="/about"
      />
      <div className="min-h-screen">
        <About data={data.main} />
        <Resume data={data.resume} />
      </div>
    </>
  );
};

export default AboutWrapper;
